import { render, staticRenderFns } from "./PropertyButtonGrid.vue?vue&type=template&id=60d34dd8&"
import script from "./PropertyButtonGrid.vue?vue&type=script&lang=js&"
export * from "./PropertyButtonGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports